import React from "react";
import project from "../assets/project.svg";
import typicalhiring from "../assets/typicalhiring.png";

const HiringProcess = () => {
  return (
    <section className="py-3 hiring-process container">
      <div data-aos="fade-up">
        <h4 className="text-center font-heading m-0 lh-small">Your Team, Our Developers</h4>
        <p className="text-center pb-3">
          Get your product built by top developers in wedevelopers
        </p>
      </div>

      <div className="row align-items-center justify-content-center">
        <div className="col-md-5 mr-2">
          <div className="pb-4">
            <div>
              <h5 className="font-normal d-flex">
                <span className="mr-50">
                  <i className="fas fa-check"></i>
                </span>
                Get top quality talents
              </h5>
              <p>
                We filter out top quality talent through our rigorous assessment
                of developers by skills and experience
              </p>
            </div>
          </div>
          <div className="pb-4">
            <div>
              <h5 className="font-normal d-flex">
                <span className="mr-50">
                  <i className="fas fa-check"></i>
                </span>
                Trusted global talent pool
              </h5>
              <p>Access "hidden talents" developers outside your local area.</p>
            </div>
          </div>
          <div className="pb-4">
            <div>
              <h5 className="font-normal d-flex">
                <span className="mr-50">
                  <i className="fas fa-check"></i>
                </span>
                Hire 100x faster
              </h5>
              <p>Hire and get your project done asap.</p>
            </div>
          </div>
        </div>
        <div className="row col-md-7 image h-100 shadow rounded-sm px-0">
          <div className="images d-flex justify-content-center align-items-center py-5 px-2 col-6">
            <img src={project} className="w-100" alt="project" />
          </div>
          <div className="bg-grey images d-flex justify-content-center align-items-center col-6 py-5 px-2">
            <img src={typicalhiring} className="w-100" alt="hiring" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HiringProcess;
